import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class SearchService {
    private static instance: SearchService = null;

    category = new BehaviorSubject('creative');
    search = new BehaviorSubject('');


    public static getInstance(): SearchService {
        if (SearchService.instance === null) {
            SearchService.instance = new SearchService();
        }
        return SearchService.instance;
    }

    setCategory(categoryText: any) {
        this.category.next(categoryText);
    }

    setSearch(searchText: any) {
        this.search.next(searchText);
    }
}
